import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import FacebookIcon from "@mui/icons-material/Facebook";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Switch from "@mui/material/Switch";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import AuthService from "../../../AuthService";
import Utils from "../../../utils";
import { converteData } from "../utils/convertData";
import CommonTitle from "./CommonTitle";
import CoverInput from "./CoverInput";
import DialogProfileLogo from "./DialogProfileLogo";
import { TextMaskCep } from "./TextMaskCep";

const FormEmpresa = () => {
  const [empresa, setEmpresa] = useState({
    nome: "",
    razaoSocial: "",
    cpfCnpj: "",
    representante: "",
    cep: "",
    endereco: "",
    numero: "",
    bairro: "",
    complemento: "",
    estado: { id: "" },
    municipio: { id: "" },
    tipoIdentificadorPrincipal: "",
    tipoIdentificadorSecundario: "",
    tempoValidadeQrcodeMinutos: 30,
    chamarGarcom: false,
    urlFacebook: "",
    urlInstagram: "",
    foneWhatsapp: "",
    ativo: true,
    formatoLogo: "square",
    tipoConta: "",
    plano: null,
  });
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const usuario = JSON.parse(localStorage.getItem("_profile"));

  useEffect(() => {
    carregarEstados();
    carregarPlanos();
    handleList();
    //eslint-disable-next-line
  }, []);

  const usuarioLogado = () => {
    const service = new AuthService();
    return service.getProfile();
  };

  const handleList = () => {
    const service = new AuthService();
    service
      .get("/login/usuarioLogado")
      .then((retorno) => {
        retorno.empresa.dataBloqueio = converteData(
          retorno.empresa.dataBloqueio
        );
        retorno.empresa.tipoConta =
          retorno.empresa.tipoConta === "" ? "semConfig" : "TEMPORARIA";
        setEmpresa(retorno.empresa);
        carregarMunicipios(retorno.empresa.estado?.id);
      })
      .catch((err) => {
        console.error(err);
        const errorMessage = err.response
          ? err.response.json().errorMessage
          : "Erro ao buscar informações do usuário";
        enqueueSnackbar(errorMessage, { variant: "error" });
      });
  };

  const handleChange = (event) => {
    setEmpresa((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleChangePlano = (event) => {
    const idPlano = event.target.value;

    if (idPlano === "-1") {
      setEmpresa((prev) => ({ ...prev, plano: null }))
    } else {
      const planoSelecionado = planos.find((p) => p.id === idPlano)
      setEmpresa((prev) => ({ ...prev, plano: planoSelecionado }))
    }
  }

  const handleChecked = (event) => {
    setEmpresa((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  const handleCheckedMostraLoja = (event) => {
    setEmpresa((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = () => {
    const service = new AuthService();
    if (empresa.urlHook) {
      empresa.urlHook = empresa.urlHook.trim();
    }

    if (empresa.tipoConta === "semConfig") {
      empresa.tipoConta = "";
    }

    empresa.dataBloqueio = converteData(empresa.dataBloqueio);

    service
      .post("/empresa", empresa)
      .then((retorno) => {
        enqueueSnackbar("Dados atualizados com sucesso", {
          variant: "success",
        });
        let profile = JSON.parse(localStorage.getItem("_profile"));
        profile.empresa = retorno;
        setEmpresa(retorno);
        localStorage.setItem("_profile", JSON.stringify(profile));
      })
      .catch((err) => {
        const errorMessage = err.response
          ? err.response.json().errorMessage
          : "Erro ao salvar empresa";
        enqueueSnackbar(errorMessage, { variant: "error" });
      });
  };

  const carregarPlanos = () => {
    const service = new AuthService();
    service
      .get("/plano/list")
      .then((retorno) => setPlanos(retorno))
      .catch((err) => {
        console.error("Falha ao carregar planos", err);
      });
  };

  const carregarEstados = () => {
    const service = new AuthService();
    service
      .get("/estado/list")
      .then((retorno) => {
        setEstados(retorno);
      })
      .catch((err) => { });
  };

  const carregarMunicipios = (idEstado) => {
    const service = new AuthService();
    service.get(`/municipio/listByEstadoId/${idEstado}`).then((retorno) => {
      setMunicipios(retorno);
    });
  };

  const handleChangeEstado = (event) => {
    const estado = estados.find((e) => e.id === event.target.value);
    setEmpresa((prev) => ({ ...prev, estado }));

    if (estado) {
      carregarMunicipios(estado.id);
    }
  };

  const handleChangeMunicipio = (event) => {
    const municipio = municipios.find((e) => e.id === event.target.value);
    setEmpresa((prev) => ({ ...prev, municipio }));
  };

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleSaveLogo = (newEmpresa) => {
    const service = new AuthService();
    const { id, urlLogo, formatoLogo } = newEmpresa;
    const json = { id, urlLogo, formatoLogo };

    service.put("/empresa/changeOnly", json).then((resp) => {
      const profile = JSON.parse(localStorage.getItem("_profile"));
      profile.empresa = resp;
      setEmpresa(resp);
      localStorage.setItem("_profile", JSON.stringify(profile));

      handleToggle();
    });
  };

  const handleSearchByCep = (value) => {
    empresa.cep = value;

    if (Utils.onlyDigits(value).length > 7) {
      let cep = value;

      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then((response) => response.json())
        .then((result) => {
          if (result.erro) {
            enqueueSnackbar("CEP não encontrado", { variant: "warning" });
            return;
          }

          setEmpresa({
            ...empresa,
            endereco: result.logradouro,
            bairro: result.bairro,
            complemento: result.complemento,
          });
        })
        .catch((err) => {
          console.error(err);
          enqueueSnackbar("Nada encontrado para o CEP informado.", {
            variant: "warning",
          });
        });
    }
  };

  const handleClickSearchByCep = () => {
    const testCep = empresa.cep;

    if (Utils.onlyDigits(testCep).length > 7) {
      fetch(`https://viacep.com.br/ws/${testCep}/json/`)
        .then((response) => response.json())
        .then((result) => {
          if (result.erro) {
            enqueueSnackbar("CEP não encontrado", { variant: "warning" });
            return;
          }

          setEmpresa({
            ...empresa,
            endereco: result.logradouro,
            bairro: result.bairro,
            complemento: result.complemento,
          });
        })
        .catch((err) => {
          console.error(err);
          enqueueSnackbar("Nada encontrado para o CEP informado.", {
            variant: "warning",
          });
        });
    } else {
      enqueueSnackbar("O cep informado não corresponde a um endereço válido", {
        variant: "error",
      });
    }
  };

  return (
    <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
      <Grid
        size={{
          xs: 12,
          sm: 12,
        }}
      >
        <Box flexDirection="row" display="flex" justifyContent="center">
          <Box
            position="relative"
            display="flex"
            justifyContent="center"
            width="100%"
            height="250px"
            mb={5}
          >
            <CoverInput
              empresa={empresa}
              onSubmit={() => handleSubmit()}
              onUpdateCompany={setEmpresa}
            />

            {empresa.urlLogo ? (
              <Avatar
                alt="Logo da empresa"
                src={empresa.urlLogo}
                variant={
                  empresa?.formatoLogo === "square" ? "rounded" : "circular"
                }
                onClick={handleToggle}
                sx={{
                  position: "absolute",
                  right: "32px",
                  bottom: "-55px",
                  width: "110px",
                  height: "110px",
                  cursor: "pointer",
                  zIndex: 1,
                  transition: "0.2s",
                  "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: "0",
                    transition: "0.2s",
                    backgroundColor: "#000",
                    zIndex: 1,
                  },
                  "&:hover:before": {
                    opacity: "0.6",
                  },
                }}
              />
            ) : (
              <Avatar
                alt="Logo da empresa"
                variant={
                  empresa?.formatoLogo === "square" ? "rounded" : "circular"
                }
                onClick={handleToggle}
                sx={{
                  position: "absolute",
                  right: "32px",
                  bottom: "-55px",
                  width: "110px",
                  height: "110px",
                  cursor: "pointer",
                  zIndex: 1,
                  transition: "0.2s",
                  "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    opacity: "0",
                    transition: "0.2s",
                    backgroundColor: "#000",
                    zIndex: 1,
                  },
                  "&:hover:before": {
                    opacity: "0.6",
                  },
                }}
              >
                <AddAPhotoIcon style={{ fontSize: "50px" }} />
              </Avatar>
            )}
          </Box>

          <DialogProfileLogo
            open={open}
            empresa={empresa}
            onClose={handleToggle}
            onConfirm={handleSaveLogo}
          />
        </Box>
      </Grid>
      <Box width="100%" mt="2rem">
        <CommonTitle title="Dados da empresa" />
      </Box>
      <Grid
        size={{
          xs: 12,
          sm: 12,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label={"Nome Fantasia"}
          name="nome"
          value={empresa.nome || ""}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 8,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label={"Razão Social"}
          name="razaoSocial"
          value={empresa.razaoSocial || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label={"CPF/CNPJ"}
          name="cpfCnpj"
          value={empresa.cpfCnpj || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 12,
        }}
      >
        <TextField
          fullWidth
          variant={usuario.admin ? "outlined" : "filled"}
          label={"Empresa responsável pelo seu sistema"}
          name="representante"
          value={empresa.representante || ""}
          InputProps={{
            readOnly: !usuario.admin,
          }}
          onChange={handleChange}
        />
      </Grid>
      <Box width="100%" mt="2rem">
        <CommonTitle title="Endereço" />
      </Box>
      <Grid
        size={{
          xs: 6,
          sm: 2,
        }}
      >
        <TextField
          select
          label="País"
          value={empresa.idPais || ""}
          name="idPais"
          onChange={(event) => handleChange(event)}
          fullWidth
          variant="outlined"
        >
          <MenuItem key={1058} value={1058}>
            BRASIL
          </MenuItem>
          <MenuItem key={3999} value={3999}>
            JAPÃO
          </MenuItem>
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 4,
        }}
      >
        <TextField
          select
          label="Estado"
          value={empresa.estado?.id || ""}
          name="estado"
          onChange={(event) => handleChangeEstado(event)}
          fullWidth
          variant="outlined"
        >
          {estados.map((estado) => (
            <MenuItem key={estado.id} value={estado.id}>
              {estado.nome}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <TextField
          select
          label="Município"
          value={empresa.municipio?.id || ""}
          name="municipio"
          onChange={(event) => handleChangeMunicipio(event)}
          fullWidth
          variant="outlined"
        >
          {municipios.map((municipio, index) => (
            <MenuItem key={index} value={municipio.id}>
              {municipio.nome}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2,
        }}
      >
        <TextField
          label="CEP"
          fullWidth
          value={empresa.cep || ""}
          name="cep"
          variant="outlined"
          onChange={(event) => {
            const rawCep = event.target.value.replace(/\D/g, "");
            if (rawCep.length <= 8) {
              setEmpresa((prev) => ({ ...prev, cep: event.target.value }));
              if (rawCep.length === 8) {
                handleSearchByCep(rawCep);
              }
            }
          }}
          InputProps={{
            inputComponent: TextMaskCep,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClickSearchByCep} size="small">
                  <FindReplaceIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 8,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label={"Endereço"}
          name="endereco"
          value={empresa.endereco || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          label={"Número"}
          name="numero"
          value={empresa.numero || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <React.Fragment>
        <Grid
          size={{
            xs: 12,
            sm: 12,
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            label={"Bairro"}
            name="bairro"
            value={empresa.bairro || ""}
            onChange={(event) => handleChange(event)}
          />
        </Grid>

        <Grid size={12}>
          <TextField
            fullWidth
            variant="outlined"
            label={"Complemento"}
            name="complemento"
            value={empresa.complemento || ""}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
      </React.Fragment>
      <Box width="100%" mt="2rem">
        <CommonTitle title="Social" />
      </Box>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <TextField
          variant="outlined"
          label="WhatsApp"
          name="foneWhatsapp"
          fullWidth
          value={empresa.foneWhatsapp || ""}
          placeholder="Número do WhatsApp"
          onChange={(event) => handleChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <WhatsAppIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <TextField
          variant="outlined"
          label="Instagram"
          name="urlInstagram"
          fullWidth
          value={empresa.urlInstagram || ""}
          placeholder="URL da sua página no insta"
          onChange={(event) => handleChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <InstagramIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <TextField
          variant="outlined"
          label="Facebook"
          name="urlFacebook"
          fullWidth
          value={empresa.urlFacebook || ""}
          placeholder="URL da sua página no face"
          onChange={(event) => handleChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FacebookIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <TextField
          variant="outlined"
          label="Pixel do Facebook"
          name="pixelFacebookId"
          fullWidth
          value={empresa.pixelFacebookId || ""}
          placeholder="id do pixel do facebook"
          onChange={(event) => handleChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FacebookIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Box width="100%" mt="2rem">
        <CommonTitle title="Forma de atendimento" />
      </Box>
      <Grid size={12}>
        <TextField
          id="plano"
          label="Forma de atendimento"
          variant="outlined"
          name="plano"
          fullWidth
          value={empresa.plano?.id || "-1"}
          select
          disabled={!usuarioLogado().admin}
          onChange={handleChangePlano}
        >
          <MenuItem value={"-1"}>
            <em>Escolha o formato de atendimento</em>
          </MenuItem>

          {planos.map((plano) => (
            <MenuItem key={plano.id} value={plano.id}>
              {plano.descricao}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {usuario.admin && (
        <React.Fragment>
          <Grid
            size={{
              xs: 6,
              sm: 3,
            }}
          >
            <TextField
              name="idExterno"
              value={empresa.idExterno ? empresa.idExterno : ""}
              variant="outlined"
              label="Id Externo"
              fullWidth
              onChange={handleChange}
            />
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 3,
            }}
          >
            <TextField
              id="mostrarLoja"
              label="Mostrar loja no marketplace?"
              variant="outlined"
              name="mostrarLoja"
              fullWidth
              select
              value={empresa.mostrarLoja || ""}
              onChange={(event) => handleCheckedMostraLoja(event)}
            >
              <MenuItem key={"SIM"} value={"SIM"}>
                SIM
              </MenuItem>
              <MenuItem key={"NAO"} value={"NAO"}>
                NÃO
              </MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 3,
            }}
          >
            <TextField
              id="moeda"
              label="Moeda"
              variant="outlined"
              name="moeda"
              fullWidth
              select
              value={empresa.moeda || ""}
              onChange={(event) => handleCheckedMostraLoja(event)}
            >
              <MenuItem key={"IENE"} value={"IENE"}>
                ￥ ( IENE )
              </MenuItem>
              <MenuItem key={"REAL"} value={"REAL"}>
                R$ ( REAL )
              </MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 6,
              sm: 3,
            }}
          >
            <TextField
              id="tipoConta"
              label="Tipo conta"
              variant="outlined"
              name="tipoConta"
              fullWidth
              select
              value={empresa.tipoConta || ""}
              onChange={(event) => handleCheckedMostraLoja(event)}
            >
              <MenuItem key={"semConfig"} value={"semConfig"}>
                Sem configuração
              </MenuItem>
              <MenuItem key={"TEMPORARIA"} value={"TEMPORARIA"}>
                Temporaria
              </MenuItem>
            </TextField>
          </Grid>
          <Box
            display="flex"
            justifyContent="flex-start"
            width="100%"
            padding="1rem"
          >
            <Grid
              size={{
                xs: 6,
                sm: 3,
              }}
            >
              <FormControlLabel
                name="ativo"
                control={
                  <Switch
                    checked={empresa.ativo}
                    color="primary"
                    onChange={(event) => handleChecked(event)}
                  />
                }
                label={"Empresa ativa"}
              />
            </Grid>
          </Box>

          <CommonTitle title="Configurações do Webhook" />

          <Grid
            size={{
              xs: 12,
              sm: 2,
            }}
          >
            <TextField
              id="statusHook"
              label="Status do webhook"
              variant="outlined"
              name="statusHook"
              fullWidth
              select
              value={empresa.statusHook || ""}
              onChange={(event) => handleChange(event)}
            >
              <MenuItem key={"INATIVO"} value={"INATIVO"}>
                Inativo
              </MenuItem>
              <MenuItem key={"ATIVO"} value={"ATIVO"}>
                ATIVO
              </MenuItem>
            </TextField>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 7,
            }}
          >
            <TextField
              id="urlHook"
              label="URL do webhook"
              variant="outlined"
              name="urlHook"
              fullWidth
              value={empresa.urlHook || ""}
              onChange={(event) => handleChange(event)}
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 3,
            }}
          >
            <TextField
              id="id"
              label="Id loja Qrpedir"
              variant="outlined"
              name="id"
              fullWidth
              disabled
              value={empresa.id || ""}
            />
          </Grid>
        </React.Fragment>
      )}
      <Box
        display="flex"
        width="100%"
        marginTop="1rem"
        justifyContent="flex-end"
      >
        <Box width="24%">
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
          >
            SALVAR
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default FormEmpresa;
